<template>
  <x-page-plus>
    <div :class="_.message">请返回APP查看订单</div>
  </x-page-plus>
</template>

<script>
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'

  export default Vue.extend({
    mounted() {
      dcb.closeWindow()
    },
  })
</script>

<style lang="scss" module>
  .message {
    font-size: 20px;
    padding: 20px;
    text-align: center;
  }
</style>
